export default __webpack_public_path__ + "static/media/angela.4f6d066e.jpg";